/* eslint-disable @typescript-eslint/no-explicit-any */

import { MantineColorScheme } from '@mantine/core'
export const $ = (...args: any[]) => args.filter(Boolean).join(' ')

export function getColorScheme() {
  return document.documentElement.getAttribute('data-mantine-color-scheme') as MantineColorScheme
}
